// http://stackoverflow.com/a/9640417
export const toSeconds = (str: string) => {
  const p = str.split(':');
  let s = 0;
  let m = 1;

  while (p.length > 0) {
    s += m * parseInt(p.pop() || '', 10);
    m *= 60;
  }

  return s;
};

// https://stackoverflow.com/a/11486026
export const fromSeconds = (time: number) => {
  // Hours, minutes and seconds
  var hrs = ~~(time / 3600);
  var mins = ~~((time % 3600) / 60);
  var secs = ~~time % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  var ret = '';

  if (hrs > 0) {
    ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
  }

  ret += '' + mins + ':' + (secs < 10 ? '0' : '');
  ret += '' + secs;
  return ret;
};

export const toDateTime = (seconds: number) => {
  var t = new Date(Date.UTC(0, 0, 0, 0, 0, 0));
  t.setSeconds(seconds);
  return t;
};
